<script lang="ts" setup>
import postContact from '@/api/admin/index';
import { computed, ref, onMounted } from 'vue';
import { useAlertsStore } from '@/stores/alerts';
import { useLocalizationStore } from '@/stores/localization';
import { storeToRefs } from 'pinia';

import formAlerts from '@/components/form-alerts/form-alerts.vue';


import config from '@/config';

import { useForm } from 'vee-validate';
import * as yup from 'yup';
import type { Contact } from '@/ontology/admin';

const activeQuestion = ref(0);
const faqData = ref(undefined);
const props = defineProps<{ pageData: string }>();
let formAlert = ref();

const { openMessage } = useAlertsStore();
const { language } = storeToRefs(useLocalizationStore());

const activeValidation = ref(false);
const validate = computed(() => {
    return yup.object({
        email: yup.string().email().required(),
        message: yup.string().required(),
        name: yup.string().required(),
        subject: yup.string().required()
    });
});

const { errors, useFieldModel, handleSubmit, handleReset } = useForm({
    validationSchema: validate
});
const [email, message, name, subject] = useFieldModel(['email', 'message', 'name', 'subject']);

onMounted(load);

async function load() {
    await getFaq();
}

function getItems(data: any){
    const lang = language!.value ? language!.value : 'en';
    return data[lang as any];
}

async function getFaq(){
    const response = await fetch(`/themes/${config.Themename}/assets/textpages/faq.data.json`);
    faqData.value = await response.json();
}

const onSubmit = handleSubmit(async (values, { resetForm }) => {
    activeValidation.value = true;
    const { error } = await postContact(values as Contact);
    activeValidation.value = false;

    if (error) {
        await formAlert.value.addMsg({type: 'error', content: 'textpages.alerts.errorSend'});
        return;
    }

    handleReset();
    formAlert.value.addMsg({type: 'success', content: 'textpages.alerts.successSend'});
});
</script>

<template src="./contact.html"></template>